module.exports = __webpack_public_path__ + "static/media/072-denmark.d8c4696e.svg";